import { render, staticRenderFns } from "./IntroSkipButton.vue?vue&type=template&id=05e50380&scoped=true&"
import script from "./IntroSkipButton.vue?vue&type=script&lang=js&"
export * from "./IntroSkipButton.vue?vue&type=script&lang=js&"
import style0 from "./IntroSkipButton.vue?vue&type=style&index=0&id=05e50380&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e50380",
  null
  
)

export default component.exports